import {Injectable} from '@angular/core';
import {
    WorkbenchPlugin,
    WorkbenchPluginId,
    ViewTemplateId,
    WorkbenchViewTemplateConfig,
    WorkbenchViewConfig,
    OpenScreenshotEvent,
    WorkbenchViewKind
} from '../../shared/types';
import {Observable, of} from 'rxjs';
import {WorkbenchLayoutManager} from '../../shared/services/workbench-layout-manager.service';
import {WorkbenchContextService} from '../../shared/services/workbench-context.service';
import {LocalScreenshotId, ProjectId, ScreenshotId} from '@webmate-web-core/shared/types/ids';
import _ from 'lodash';
import {ScreenshotViewConfig, WorkbenchScreenshotViewerComponent} from './workbench-screenshot-viewer.component';
import {CENTER_VIEW_CONTAINER_CONFIG, CENTER_VIEW_CONTAINER_ID} from '../../shared/components/viewcontainers/viewcontainers';
import {WorkbenchCommandRegistry} from '../../shared/services/workbench-command-registry.service';
import {InspectorService} from '../../shared/services/inspector.service';



@Injectable()
export class ScreenshotPlugin extends WorkbenchPlugin{
    id: WorkbenchPluginId = 'screenshot';
    projectId: ProjectId;
    views: WorkbenchViewKind[];

    static readonly ViewTemplateId: ViewTemplateId = 'screenshot.screenshot-view-template';

    constructor(readonly layoutManager: WorkbenchLayoutManager,
                private readonly workbenchContextService: WorkbenchContextService,
                private readonly commandRegistry: WorkbenchCommandRegistry,
                private readonly inspectorService: InspectorService,) {
        super(layoutManager);
        this.workbenchContextService.subscribeWorkbenchContext$().subscribe(context => this.projectId = context.project);

        const consoleViewTemplate: WorkbenchViewTemplateConfig<ScreenshotViewConfig> = {
            templateId: ScreenshotPlugin.ViewTemplateId,
            component: WorkbenchScreenshotViewerComponent,
            icon: {
                type: 'faIcon',
                instance: "camera"
            },

            defaultViewContainer: CENTER_VIEW_CONTAINER_ID,

            init: (d: {id?: ScreenshotId, localScreenshotId?: LocalScreenshotId, name?: string}) => {
                let config = _.cloneDeep(consoleViewTemplate) as WorkbenchViewConfig<ScreenshotViewConfig>;
                if (d.id){
                    config.id = 'screenshot.view.' + (d.id);
                }
                if (d.localScreenshotId){
                    config.id = 'screenshot.view.' + d.localScreenshotId;
                }
                config.fromTemplate = ScreenshotPlugin.ViewTemplateId;
                config.name = d.name || 'Screenshot View';
                config.payload = {
                    data: {
                        screenshotId : d.id,
                        localScreenshotId: d.localScreenshotId
                    }
                };
                return config as WorkbenchViewConfig<ScreenshotViewConfig>;
            }
        };

        this.views = [consoleViewTemplate];
    }

    onWorkbenchDestroy(): void {
    }

    onWorkbenchInit(): Observable<void> {
        this.layoutManager.registerViewContainer(CENTER_VIEW_CONTAINER_CONFIG);

        this.commandRegistry.registerCommand(
            "screenshot:openScreenshotTools",
            {
                name: 'Open specific Tools for Screenshot',
            },
            (params: any) => {
                this.inspectorService.changeItem('Screenshot');
                const event: OpenScreenshotEvent = {type: 'OpenScreenshot', localId: params.localId, id: params.id, inEditMode: params.inEditMode};
                setTimeout(() => this.inspectorService.raiseInspectorEvent(event));
            }
        )

        return of(undefined);
    }
}
